const baseUri = 'attachments';

export default {
  store(data) {
    return api.post(`${baseUri}`, data);
  },

  remove(id) {
    return api.delete(`${baseUri}/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/js/api/attachment.js